module.exports = __webpack_public_path__ + "img/0010.294d3ed1.jpg";